import { render, staticRenderFns } from "./CarouselProjects.vue?vue&type=template&id=4b5081c4&"
import script from "./CarouselProjects.vue?vue&type=script&lang=js&"
export * from "./CarouselProjects.vue?vue&type=script&lang=js&"
import style0 from "./CarouselProjects.vue?vue&type=style&index=0&id=4b5081c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports